import { useEffect, useState } from "react";
import axios from "axios";
import AudioPlayer from "@/components/AudioPlayer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LANGS = [{ key: "tori", label: "Tori" }];

export default function LifeAudio() {
  const [tracks, setTracks] = useState({ fr: null, tori: null, goun: null });

  useEffect(() => {
    axios.get(`${API}/life-audio`).then((r) => setTracks(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto grid max-w-sm gap-4">
      {LANGS.map((l) => (
        <div key={l.key} data-testid={`life-audio-${l.key}`}>
          <p className="mb-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400">
            Écouter en {l.label}
          </p>
          <AudioPlayer
            src={tracks?.[l.key] ? `${API}/files/${tracks[l.key]}` : null}
            testId={`life-player-${l.key}`}
            emptyMessage={`L'audio en ${l.label} sera bientôt disponible.`}
          />
        </div>
      ))}
    </div>
  );
}
